import React from "react";
import { Box, Container } from "@mui/material";
import { C, CONTAINER, accountRootSx } from "../accountStyles";
import AccountHeader from "./AccountHeader";


export default function AccountLayout({ title, subtitle, eyebrow, initials, children }) {
  return (
    <Box sx={{ ...accountRootSx, bgcolor: C.paper }}>
      <AccountHeader eyebrow={eyebrow} title={title} subtitle={subtitle} initials={initials} />
      <Container maxWidth={CONTAINER} sx={{ pt: { xs: 4, md: 7 }, pb: { xs: 8, md: 12 } }}>
        {children}
      </Container>
    </Box>
  );
}
